"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.NavWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NavWrapper = exports.NavWrapper = /*#__PURE__*/(0, _base.default)("nav", process.env.NODE_ENV === "production" ? {
  target: "e1bwu7311"
} : {
  target: "e1bwu7311",
  label: "NavWrapper"
})();
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("ul", process.env.NODE_ENV === "production" ? {
  target: "e1bwu7310"
} : {
  target: "e1bwu7310",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:column;width:", props.small ? '80%' : 'calc(100% - 26px)', ";margin-left:", props.small ? '20%' : '0', ";margin-top:10vh;padding-left:", props.small ? '0' : '26px', ";overflow:hidden;overflow-y:auto;@media screen and (max-height: ", _breakpoints.default.heightMedium, "){margin-top:5vh;}@media screen and (max-height: ", _breakpoints.default.heightSmall, "){margin-top:1vh;}@media screen and (max-width: ", _breakpoints.default.medium, "){margin-top:1em;padding-left:0;width:100%;margin-left:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));